export enum  Nationality{

    SPANISH = 'SPANISH' ,

    COMMUNITY = 'MCOMMUNITYARRIED' ,

    EXTRACOMMUNITY = 'EXTRACOMMUNITY'
}